export const validateForm = (formData) => {
  const errors = {};

  // Check if FirstName is empty
  if (!formData.FirstName.trim()) {
    errors.FirstName = 'Please enter a valid First Name';
  }

  // Check if LastName is empty
  if (!formData.LastName.trim()) {
    errors.LastName = 'Please enter a valid Last Name';
  }

  // Check if Gender is selected
  if (!formData.Gender) {
    errors.Gender = 'Please select a Gender';
  }

  // Check if PhoneNumber is a valid number
  if (!/^\d{11}$/.test(formData.PhoneNumber)) {
    errors.PhoneNumber = 'Please enter a valid 11-digit Phone Number';
  }

  // Check if Next ofPhoneNumber is a valid number
  if (!/^\d{11}$/.test(formData.NextOfKinPhone)) {
    errors.NextOfKinPhone = 'Please enter a valid 11-digit Next of kin Phone Number';
  }


  // Check if Next of Kin Phone Number is a valid number
  // if (!/^\d{11}$/.test(formData.PhoneNumber)) {
  //   errors.PhoneNumber = 'Please enter a valid 10-digit Phone Number';
  // }


  // Check if Email is a valid email address
  if (!/^\S+@\S+\.\S+$/.test(formData.Email)) {
    errors.Email = 'Please enter a valid Email address';
  }

  // Check if DateOfBirth is a valid date
  if (!formData.DateOfBirth || Number.isNaN(new Date(formData.DateOfBirth).getTime())) {
    errors.DateOfBirth = 'Please enter a valid Date of Birth';
  }

  // Check if MemberType is selected
  if (!formData.MemberType) {
    errors.Gender = 'Please select a MemberType';
  }

  if (!formData.NextOfKin) {
    errors.NextOfKin = 'Please enter a valid Kin Name ';
  }

  // Check if DateOfBirth is a valid date
  // if (!formData.MarriageAnniversary || Number.isNaN(new Date(formData.MarriageAnniversary).getTime())) {
  //   errors.MarriageAnniversary = 'Please enter a valid Marriage Anniversary';
  // }

  // Check if Country is selected
  if (!formData.Country) {
    errors.Gender = 'Please select a Country';
  }

  // Check if State is selected
  // if (!formData.State) {
  //   errors.State = 'Please select a State';
  // }

  // Check if Department is selected
  if (!formData.Department) {
    errors.Gender = 'Please select a Department';
  }

  // Check if Address is empty
  if (!formData.Address.trim()) {
    errors.Address = 'Please enter a valid Address';
  }

  // Check if YearJoined is a valid date
  if (!formData.YearJoined || Number.isNaN(new Date(formData.YearJoined).getTime())) {
    errors.YearJoined = 'Please enter a valid Year Joined';
  }

  return errors;
};
